import Modal from 'developer_components/newModal';
import EventEmitter from 'methods/eventEmitter';

/**
 * Модалка забыл пароль
 */
function ForgotModal() {
    // наследуемся
    EventEmitter.call(this);
    this.modal_id  = 'forgot';
    this._$element = Modal.createFromHTML(
        `<div class="Forgot-modal container">
            <div class="background"></div>
            <div class="form">
                <div class="form-header">
                    <div class="mobile-wrapper">
                        <div class="logo"></div>
                        <button class="close-button js-modalClose"></button>
                    </div>
                    <div class="cross-wrapper"><div class="cross js-modalClose"></div></div>
                </div>
                <div class="form-content">
                    <div class="header-title">Восстановление пароля</div>
                    <div class="header-subtitle">Напишите  E-mail, указанный при регистрации. Туда будет отправлена инструкция по восстановлению</div>
                    <form action="/users_v2/forgot/" method="post" class="fields">
                        <div class="field" data-type="email">
                            <span class="title">E-mail</span>
                            <input type="text" class="input" name="email" required autocomplete="email">
                            <span class="hint"></span>
                        </div>

                        <button class="button">Отправить</button>
                    </form>
                </div>
                <div class="form-footer">
                    <span class="link gray" data-modal_id="authorization">Войти</span>
                    <span class="link gray" data-modal_id="registration">Зарегистрироваться</span>
                </div>
            </div>
        </div>`,
        {
            id: this.modal_id,
        }
    );

    // наследование
    Modal.call(this, this._$element, {
        modal_id: this.modal_id,
    });

    this._events = {
        submit: (e) => {
            e.preventDefault();
            e.stopPropagation();

            // защита от повторной отправки
            if (this._$form.classList.contains('is-loading')) {
                return false;
            }
            this._$form.classList.add('is-loading');

            // убираем ошибки
            this._$element.querySelectorAll('.field').forEach($field => {
                $field.classList.remove('error');

                let $hint = $field.querySelector('.hint');
                if ($hint) {
                    $hint.textContent = '';
                }
            });

            fetch(this._$form.getAttribute('action'), {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new FormData(this._$form),
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok' && r.email) {
                    this.emit('success', r.email);
                } else if (r.fields) {
                    this._$element.querySelectorAll('.field').forEach($field => {
                        let name = $field.dataset.type;

                        if (name && r.fields[name]) {
                            $field.classList.add('error');

                            let $hint = $field.querySelector('.hint');
                            if ($hint) {
                                $hint.textContent = r.fields[name];
                            }
                        }
                    });
                } else if (r.message) {
                    alert(r.message);
                }

                this._$form.classList.remove('is-loading');
            });
        }
    }

    this.init = function() {
        this._$form = this._$element.querySelector('form');
        this._$form.addEventListener('submit', this._events.submit);
    }
    this.init();
}

ForgotModal.prototype = Object.create(Modal.prototype, {
    constructor: {
        value: ForgotModal,
        enumerable: false,
        writable: true,
    }
});

export default ForgotModal;